var TOAST_DURATION_IN_SECONDS = 6;

export { TOAST_DURATION_IN_SECONDS };
